import { useEffect } from 'react';

export function Analytics() {
  // GTM is loaded via index.html - this component is now a no-op
  // but kept for backward compatibility in case App.jsx imports it
  return null;
}

/**
 * Push events to GTM dataLayer
 * Works with Google Tag Manager (GTM-P28D2GFT)
 */
function pushToDataLayer(event, data = {}) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: event,
      ...data,
    });
  }
}

export function trackEvent(eventName, eventParams = {}) {
  pushToDataLayer(eventName, eventParams);
}

export function trackFormSubmission(formName, additionalParams = {}) {
  pushToDataLayer('form_submission', {
    event_category: 'contact',
    event_label: formName,
    ...additionalParams,
  });
}
